



// import React from 'react';
// import { Helmet } from 'react-helmet-async';
// import { motion } from 'framer-motion';
// import { Link } from 'react-router-dom';
// import DigitalCalculator from '../components/Calculators/DigitalCalculator';
// import WealthGraphic from '../components/WealthGraphic';
// import { FaArrowRight } from 'react-icons/fa';

// const Home = () => {
//   const expertServices = [
//     { name: 'Mutual Funds', desc: 'Achieve financial growth with ease.', icon: '📊' },
//     { name: 'Equity', desc: 'Capitalize on market opportunities.', icon: '📈' },
//     { name: 'Retirement Planning', desc: 'Secure your golden years.', icon: '👴' },
//     { name: 'Health Insurance', desc: 'Protect your family\'s health.', icon: '🏥' },
//     { name: 'Home Loans', desc: 'Make your dream home a reality.', icon: '🏠' },
//     { name: 'Tax Planning', desc: 'Save tax, invest smart.', icon: '📋' },
//   ];

//   const stats = [
//     { value: '500+', label: 'Happy Clients' },
//     { value: '1000+', label: 'Investments Done' },
//     { value: '25+', label: 'Years Experience' },
//     { value: '50Cr+', label: 'Wealth Managed' },
//   ];

//   return (
//     <>
//       <Helmet>
//         <title>Wisdom Consultancy - Secure Your Financial Future | Smart Investment Solutions</title>
//         <meta name="description" content="Expert investment advisory services, retirement planning, wealth management, and financial solutions in Vadodara." />
//       </Helmet>

//       {/* Hero Section - Reduced padding on mobile */}
//       <section className="relative min-h-screen flex items-center bg-white overflow-hidden pt-16 md:pt-20">
//         <div className="container-custom py-8 md:py-20">
//           <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
//             <motion.div
//               initial={{ opacity: 0, x: -30 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               <span className="inline-block px-3 py-1 bg-blue-100 text-blue-600 text-xs md:text-sm font-semibold rounded-full mb-3 md:mb-4">
//                 # Wealth Consultation
//               </span>
//               <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 mb-3 md:mb-4 leading-tight">
//                 Wealth Security <br />Starts with <span className="text-blue-600">Smart Investing</span>
//               </h1>
//               <p className="text-base md:text-xl mb-4 md:mb-6 text-gray-600">
//                 Confidently manage your wealth with our tailored, secure, and efficient investment solutions.
//               </p>
//               <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
//                 <Link to="/contact" className="bg-blue-600 text-white px-6 md:px-8 py-2.5 md:py-3 rounded-lg font-semibold hover:bg-blue-700 transition-all text-center text-sm md:text-base">
//                   Start Investing
//                 </Link>
//                 <Link to="/calculators" className="border-2 border-gray-300 text-gray-700 px-6 md:px-8 py-2.5 md:py-3 rounded-lg font-semibold hover:border-blue-600 hover:text-blue-600 transition-all text-center text-sm md:text-base">
//                   Try Calculators
//                 </Link>
//               </div>
//             </motion.div>

//             <motion.div
//               initial={{ opacity: 0, x: 30 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//               className="mt-6 md:mt-0"
//             >
//               <WealthGraphic />
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Features Section - Reduced padding on mobile */}
//       <section className="py-12 md:py-20 bg-gray-50">
//         <div className="container-custom">
//           <div className="text-center mb-8 md:mb-12">
//             <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-2 md:mb-4">
//               Why Choose <span className="text-blue-600">Wisdom Consultancy?</span>
//             </h2>
//             <p className="text-sm md:text-lg text-gray-600 px-4 md:px-0">We provide comprehensive financial solutions tailored to your needs</p>
//           </div>
          
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8">
//             {[
//               { title: 'Expert Guidance', desc: 'Get advice from certified financial experts', icon: '🎯' },
//               { title: 'Secure Investments', desc: 'Your money is safe with trusted products', icon: '🔒' },
//               { title: 'Best Returns', desc: 'Maximize your wealth with high returns', icon: '📊' },
//               { title: '24/7 Support', desc: 'Round the clock customer assistance', icon: '💬' },
//             ].map((feature, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ delay: index * 0.1 }}
//                 className="text-center p-4 md:p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition-all border border-gray-100"
//               >
//                 <div className="text-4xl md:text-5xl mb-2 md:mb-4">{feature.icon}</div>
//                 <h3 className="text-base md:text-xl font-bold text-gray-900 mb-1 md:mb-2">{feature.title}</h3>
//                 <p className="text-xs md:text-sm text-gray-600">{feature.desc}</p>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Digital Tools Section - Reduced padding on mobile */}
//       <section className="py-12 md:py-20 bg-white">
//         <div className="container-custom">
//           <div className="text-center mb-8 md:mb-12">
//             <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-2 md:mb-4">
//               Digital Tools & <span className="text-blue-600">Calculators</span>
//             </h2>
//             <p className="text-sm md:text-lg text-gray-600">Plan your finances with our interactive tools</p>
//           </div>
//           <DigitalCalculator />
//         </div>
//       </section>

//       {/* Expert Services - Reduced padding on mobile */}
//       <section className="py-12 md:py-20 bg-gray-50">
//         <div className="container-custom">
//           <div className="text-center mb-8 md:mb-12">
//             <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-2 md:mb-4">
//               Invest Smarter with Our <span className="text-blue-600">Expert Services</span>
//             </h2>
//             <p className="text-sm md:text-lg text-gray-600">Comprehensive financial solutions tailored to your needs</p>
//           </div>
          
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
//             {expertServices.map((service, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ delay: index * 0.1 }}
//                 className="bg-white rounded-xl p-4 md:p-6 shadow-md hover:shadow-lg transition-all border border-gray-100 group cursor-pointer"
//               >
//                 <div className="text-3xl md:text-4xl mb-2 md:mb-4">{service.icon}</div>
//                 <h3 className="text-base md:text-xl font-bold text-gray-900 mb-1 md:mb-2">{service.name}</h3>
//                 <p className="text-xs md:text-sm text-gray-600 mb-3 md:mb-4">{service.desc}</p>
//                 <Link to="/services" className="inline-flex items-center gap-1 md:gap-2 text-blue-600 font-semibold text-sm md:text-base hover:gap-2 md:hover:gap-3 transition-all">
//                   Learn More <FaArrowRight size={12} className="md:w-[14px]" />
//                 </Link>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Stats Section - Reduced padding on mobile */}
//       <section className="py-10 md:py-16 bg-white">
//         <div className="container-custom">
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 text-center">
//             {stats.map((stat, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, scale: 0.5 }}
//                 whileInView={{ opacity: 1, scale: 1 }}
//                 transition={{ delay: index * 0.1 }}
//               >
//                 <div className="text-2xl md:text-4xl font-bold text-blue-600 mb-1 md:mb-2">{stat.value}</div>
//                 <div className="text-xs md:text-sm text-gray-600">{stat.label}</div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA Section - Reduced padding on mobile */}
//       <section className="py-12 md:py-20 bg-blue-600">
//         <div className="container-custom text-center px-4 md:px-0">
//           <h2 className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold text-white mb-3 md:mb-4">
//             Invest with Confidence – Get Expert Guidance for Free!
//           </h2>
//           <p className="text-sm md:text-base lg:text-xl mb-6 md:mb-8 text-white opacity-90 px-4 md:px-0">
//             Take the first step towards smarter investing.
//           </p>
//           <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
//             <Link 
//               to="/contact" 
//               className="bg-white text-blue-600 px-6 md:px-8 py-2.5 md:py-3 rounded-lg font-semibold hover:bg-gray-100 transition-all shadow-md text-sm md:text-base"
//             >
//               Schedule Free Consultation
//             </Link>
//             <Link 
//               to="/calculators" 
//               className="border-2 border-white text-white px-6 md:px-8 py-2.5 md:py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-all text-sm md:text-base"
//             >
//               Try Our Calculators
//             </Link>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Home;

// import React from 'react';
// import { Helmet } from 'react-helmet-async';
// import { motion } from 'framer-motion';
// import { Link } from 'react-router-dom';

// import DigitalCalculator from '../components/Calculators/DigitalCalculator';
// import WealthGraphic from '../components/WealthGraphic';

// import {
//   FaArrowRight,
//   FaChartLine,
//   FaShieldAlt,
//   FaHeadset,
//   FaBullseye,
// } from 'react-icons/fa';

// const Home = () => {
//   const expertServices = [
//     {
//       name: 'Mutual Funds',
//       desc: 'Achieve financial growth with ease.',
//       icon: '📊',
//     },
//     {
//       name: 'Equity',
//       desc: 'Capitalize on market opportunities.',
//       icon: '📈',
//     },
//     {
//       name: 'Life Insurance',
//       desc: 'Secure your family’s financial future.',
//       icon: '🛡️',
//     },
//     {
//       name: 'Health Insurance',
//       desc: "Protect your family's health.",
//       icon: '🏥',
//     },
//     {
//       name: 'Home Loans',
//       desc: 'Make your dream home a reality.',
//       icon: '🏠',
//     },
//     {
//       name: 'Car & Bike Insurance',
//       desc: 'Protect your car from unexpected risks.',
//       icon: '🚗',
//     },
//   ];

//   const stats = [
//     { value: '500+', label: 'Happy Clients' },
//     { value: '1000+', label: 'Investments Done' },
//     { value: '19+', label: 'Years Experience' },
//     { value: '50Cr+', label: 'Wealth Managed' },
//   ];

//   return (
//     <>
//       <Helmet>
//         <title>
//           Wisdom Consultancy - Secure Your Financial
//           Future
//         </title>

//         <meta
//           name="description"
//           content="Expert investment advisory services, retirement planning, wealth management, and financial solutions in Vadodara."
//         />
//       </Helmet>

//       {/* MAIN SECTION */}
//       <section className="relative overflow-hidden bg-[#f5f7f6]">
//         {/* GRID BACKGROUND */}
//         <div
//           className="absolute inset-0 opacity-40"
//           style={{
//             backgroundImage: `
//               linear-gradient(to right, #d7d7d7 1px, transparent 1px),
//               linear-gradient(to bottom, #d7d7d7 1px, transparent 1px)
//             `,
//             backgroundSize: '42px 42px',
//           }}
//         />

//         {/* HERO SECTION */}
//         <div className="container-custom relative z-10 pt-28 pb-20">
//           <div className="grid lg:grid-cols-2 gap-14 items-center">
//             {/* LEFT CONTENT */}
//             <motion.div
//               initial={{ opacity: 0, x: -40 }}
//               animate={{ opacity: 1, x: 0 }}
//             >
//               {/* BADGE */}
//               <div className="inline-flex items-center gap-3 bg-white shadow-md px-5 py-3 rounded-full mb-8">
//                 <div className="w-10 h-10 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
//                   <FaChartLine />
//                 </div>

//                 <span className="font-semibold text-[#0b1c39]">
//                   Wealth Consultation
//                 </span>
//               </div>

//               {/* TITLE */}
//               <h1 className="text-5xl md:text-7xl font-extrabold leading-tight text-[#222]">
//                 Your Trusted Partner
//                 <br />
//                 for Wealth{' '}
//                 <span className="text-[#69bf74]">
//                   & Financial Security
//                 </span>
//               </h1>

//               {/* DESC */}
//               <p className="mt-8 text-lg md:text-xl text-gray-600 leading-9 max-w-2xl">
               
//                 We provide customized financial solutions designed to protect your family, grow your investments, and achieve your life goals with confidence and clarity.
//               </p>

//               {/* BUTTONS */}
//               <div className="flex flex-col sm:flex-row gap-5 mt-10">
//                 <Link
//                   to="/contact"
//                   className="inline-flex items-center justify-center gap-3 bg-[#2e56b8] hover:bg-[#24479b] text-white px-8 py-5 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg"
//                 >
//                   Get Started
//                   <FaArrowRight />
//                 </Link>

//                 <Link
//                   to="/calculators"
//                   className="inline-flex items-center justify-center gap-3 bg-white border border-[#dbe7ff] text-[#2e56b8] px-8 py-5 rounded-full text-lg font-semibold hover:shadow-lg transition-all duration-300"
//                 >
//                   Book Free Consultation
//                 </Link>
//               </div>
//             </motion.div>

//             {/* RIGHT GRAPHIC */}
//             <motion.div
//               initial={{ opacity: 0, x: 40 }}
//               animate={{ opacity: 1, x: 0 }}
//               className="relative"
//             >
//               <WealthGraphic />
//             </motion.div>
//           </div>
//         </div>

//         {/* FEATURES */}
//         <section className="py-20 relative z-10">
//           <div className="container-custom">
//             {/* TITLE */}
//             <div className="text-center mb-16">
//               <div className="inline-flex items-center gap-3 bg-white shadow-md px-5 py-3 rounded-full mb-6">
//                 <div className="w-10 h-10 rounded-full bg-[#69bf74] flex items-center justify-center text-white">
//                   <FaBullseye />
//                 </div>

//                 <span className="font-semibold text-[#0b1c39]">
//                   Why Choose Us
//                 </span>
//               </div>

//               <h2 className="text-4xl md:text-5xl font-bold text-[#222] mb-5">
//                 Why Choose{' '}
//                 <span className="text-[#2e56b8]">
//                   Wisdom Consultancy?
//                 </span>
//               </h2>

//               <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-8">
//                 We provide comprehensive financial
//                 solutions tailored to your goals and future
//                 financial security.
//               </p>
//             </div>

//             {/* GRID */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
//               {
             
//               [
//   {
//     title: 'Expert Guidance',
//     desc: 'Professional investment and insurance solutions backed by 19+ years of industry experience.',
//     icon: '🎯',
//   },
//   {
//     title: 'Client-Centric',
//     desc: 'Every solution is customized according to your financial goals and future needs.',
//     icon: '🤝',
//   },
//   {
//     title: 'Goal-Based Wealth Planning',
//     desc: 'Strategic financial planning designed for education, retirement, wealth creation, and family security.',
//     icon: '📈',
//   },
//   {
//     title: 'Transparent & Ethical',
//     desc: 'We believe in honest guidance, complete transparency, and long-term client relationships.',
//     icon: '🛡️',
//   },

//               ].map((feature, index) => (
//                 <motion.div
//                   key={index}
//                   initial={{ opacity: 0, y: 25 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ delay: index * 0.1 }}
//                   className="bg-white rounded-[30px] p-8 shadow-md hover:shadow-2xl transition-all duration-300 border border-transparent hover:border-[#dbe7ff] text-center group"
//                 >
//                   <div className="w-20 h-20 rounded-3xl bg-[#edf3ff] flex items-center justify-center text-4xl text-[#2e56b8] mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
//                     {feature.icon}
//                   </div>

//                   <h3 className="text-2xl font-bold text-[#0b1c39] mb-4">
//                     {feature.title}
//                   </h3>

//                   <p className="text-gray-600 leading-8">
//                     {feature.desc}
//                   </p>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* DIGITAL TOOLS */}
//         <section className="py-20 relative z-10">
//           <div className="container-custom">
//             <div className="text-center mb-16">
//               <h2 className="text-4xl md:text-5xl font-bold text-[#222] mb-5">
//                 Financial {' '}
//                 <span className="text-[#69bf74]">
//                   Calculators
//                 </span>
//               </h2>

//               <p className="text-lg text-gray-600">
//                 Customized financial strategies focused on growth, protection, and future financial confidence.
//               </p>
//             </div>

//             <div className="bg-white rounded-[35px] shadow-2xl p-6 md:p-10 border border-[#edf3ff]">
//               <DigitalCalculator />
//             </div>
//           </div>
//         </section>

//         {/* SERVICES */}
//         <section className="py-20 relative z-10">
//           <div className="container-custom">
//             <div className="text-center mb-16">
//               <h2 className="text-4xl md:text-5xl font-bold text-[#222] mb-5">
//                 Empowering Your Financial Journey with{' '}
//                 <span className="text-[#2e56b8]">
//                   Expert Solutions
//                 </span>
//               </h2>

//               <p className="text-lg text-gray-600">
//                 Comprehensive financial solutions tailored
//                 to your needs.
//               </p>
//             </div>

//             {/* SERVICE GRID */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
//               {expertServices.map((service, index) => (
//                 <motion.div
//                   key={index}
//                   initial={{ opacity: 0, y: 25 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ delay: index * 0.1 }}
//                   className="group bg-white rounded-[30px] p-8 shadow-md hover:shadow-2xl transition-all duration-300 border border-transparent hover:border-[#dbe7ff]"
//                 >
//                   <div className="w-20 h-20 rounded-3xl bg-[#edf3ff] flex items-center justify-center text-4xl mb-6 group-hover:scale-110 transition-transform duration-300">
//                     {service.icon}
//                   </div>

//                   <h3 className="text-2xl font-bold text-[#0b1c39] mb-4">
//                     {service.name}
//                   </h3>

//                   <p className="text-gray-600 leading-8 mb-6">
//                     {service.desc}
//                   </p>

//                   <Link
//                     to="/services"
//                     className="inline-flex items-center gap-3 text-[#2e56b8] font-semibold text-lg hover:gap-5 transition-all duration-300"
//                   >
//                     Learn More
//                     <FaArrowRight />
//                   </Link>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* STATS */}
//         <section className="py-20 relative z-10">
//           <div className="container-custom">
//             <div className="bg-white rounded-[40px] shadow-2xl p-10 md:p-16 border border-[#e7f0eb]">
//               <div className="grid grid-cols-2 md:grid-cols-4 gap-10 text-center">
//                 {stats.map((stat, index) => (
//                   <motion.div
//                     key={index}
//                     initial={{ opacity: 0, scale: 0.5 }}
//                     whileInView={{ opacity: 1, scale: 1 }}
//                     transition={{ delay: index * 0.1 }}
//                   >
//                     <div className="text-4xl md:text-5xl font-bold text-[#2e56b8] mb-3">
//                       {stat.value}
//                     </div>

//                     <div className="text-gray-600 text-lg">
//                       {stat.label}
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* CTA */}
//         <section className="pb-24 relative z-10">
//           <div className="container-custom">
//             <div className="bg-white rounded-[40px] shadow-2xl p-10 md:p-16 text-center border border-[#e7f0eb] relative overflow-hidden">
              
//               {/* BG SHAPE */}
//               <div className="absolute top-0 right-0 w-72 h-72 bg-[#edf3ff] rounded-full blur-3xl opacity-50" />

//               <div className="relative z-10">
//                 <div className="inline-flex items-center gap-3 bg-[#edf3ff] px-5 py-3 rounded-full mb-8">
//                   <div className="w-10 h-10 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
//                     <FaChartLine />
//                   </div>

//                   <span className="font-semibold text-[#0b1c39]">
//                     Free Financial Guidance
//                   </span>
//                 </div>

//                 <h2 className="text-4xl md:text-5xl font-bold text-[#222] leading-tight mb-6">
//                   Book a Free Consultation –{' '}
//                   <span className="text-[#69bf74]">
//                     with
//                   </span>{' '}
//                   Financial Experts
//                 </h2>

//                 <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-9 mb-10">
//                   Strategic investment and insurance planning tailored to your future needs.
//                 </p>

//                 <div className="flex flex-col sm:flex-row gap-5 justify-center">
//                   <Link
//                     to="/contact"
//                     className="inline-flex items-center justify-center gap-3 bg-[#2e56b8] hover:bg-[#24479b] text-white px-8 py-5 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg"
//                   >
//                     Schedule Free Consultation
//                     <FaArrowRight />
//                   </Link>

//                   <Link
//                     to="/calculators"
//                     className="inline-flex items-center justify-center gap-3 bg-[#69bf74] hover:bg-[#58ab63] text-white px-8 py-5 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg"
//                   >
//                     Try Our Calculators
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       </section>
//     </>
//   );
// };

// export default Home;

/////////////////////////////////////////////////////////////

import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

import DigitalCalculator from '../components/Calculators/DigitalCalculator';
import WealthGraphic from '../components/WealthGraphic';

import {
  FaArrowRight,
  FaChartLine,
  FaBullseye,
  FaStar,
  FaQuoteLeft,
} from 'react-icons/fa';

const Home = () => {
  const expertServices = [
    {
      name: 'Mutual Funds',
      desc: 'Achieve financial growth with ease.',
      icon: '📊',
    },
    {
      name: 'Equity',
      desc: 'Capitalize on market opportunities.',
      icon: '📈',
    },
    {
      name: 'Life Insurance',
      desc: 'Secure your family’s financial future.',
      icon: '🛡️',
    },
    {
      name: 'Health Insurance',
      desc: "Protect your family's health.",
      icon: '🏥',
    },
    {
      name: 'Home Loans',
      desc: 'Make your dream home a reality.',
      icon: '🏠',
    },
    {
      name: 'Car & Bike Insurance',
      desc: 'Protect your car from unexpected risks.',
      icon: '🚗',
    },
  ];

  const stats = [
    { value: '500+', label: 'Happy Clients' },
    { value: '1000+', label: 'Investments Done' },
    { value: '19+', label: 'Years Experience' },
    { value: '50Cr+', label: 'Wealth Managed' },
  ];

  // TESTIMONIALS
  const testimonials = [
    {
      name: 'Rakesh Patel',
      role: 'Business Owner',
      review:
        'Wisdom Consultancy helped me plan my investments and insurance perfectly. Their guidance gave me confidence about my financial future.',
    },
    {
      name: 'Neha Shah',
      role: 'Working Professional',
      review:
        'The team explained every investment option clearly and helped me start SIPs for long-term wealth creation. Highly recommended.',
    },
    {
      name: 'Amit Desai',
      role: 'Entrepreneur',
      review:
        'Professional, transparent, and always supportive. They helped me with retirement planning and insurance solutions for my family.',
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Wisdom Consultancy - Secure Your Financial Future
        </title>

        <meta
          name="description"
          content="Expert investment advisory services, retirement planning, wealth management, and financial solutions in Vadodara."
        />
      </Helmet>

      {/* MAIN SECTION */}
      <section className="relative overflow-hidden bg-[#f5f7f6]">
        {/* GRID BACKGROUND */}
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage: `
              linear-gradient(to right, #d7d7d7 1px, transparent 1px),
              linear-gradient(to bottom, #d7d7d7 1px, transparent 1px)
            `,
            backgroundSize: '42px 42px',
          }}
        />

        {/* HERO SECTION */}
        <div className="container-custom relative z-10 pt-28 pb-20">
          <div className="grid lg:grid-cols-2 gap-14 items-center">
            {/* LEFT CONTENT */}
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              animate={{ opacity: 1, x: 0 }}
            >
              {/* BADGE */}
              <div className="inline-flex items-center gap-3 bg-white shadow-md px-5 py-3 rounded-full mb-8">
                <div className="w-10 h-10 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
                  <FaChartLine />
                </div>

                <span className="font-semibold text-[#0b1c39]">
                  Wealth Consultation
                </span>
              </div>

              {/* TITLE */}
              <h1 className="text-5xl md:text-7xl font-extrabold leading-tight text-[#222]">
                Your Trusted Partner
                <br />
                for Wealth{' '}
                <span className="text-[#69bf74]">
                  & Financial Security
                </span>
              </h1>

              {/* DESC */}
              <p className="mt-8 text-lg md:text-xl text-gray-600 leading-9 max-w-2xl">
                We provide customized financial solutions designed to protect
                your family, grow your investments, and achieve your life goals
                with confidence and clarity.
              </p>

              {/* BUTTONS */}
              <div className="flex flex-col sm:flex-row gap-5 mt-10">
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center gap-3 bg-[#2e56b8] hover:bg-[#24479b] text-white px-8 py-5 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg"
                >
                  Get Started
                  <FaArrowRight />
                </Link>

                <Link
                  to="/calculators"
                  className="inline-flex items-center justify-center gap-3 bg-white border border-[#dbe7ff] text-[#2e56b8] px-8 py-5 rounded-full text-lg font-semibold hover:shadow-lg transition-all duration-300"
                >
                  Book Free Consultation
                </Link>
              </div>
            </motion.div>

            {/* RIGHT GRAPHIC */}
            <motion.div
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              className="relative"
            >
              <WealthGraphic />
            </motion.div>
          </div>
        </div>

        {/* FEATURES */}
        <section className="py-20 relative z-10">
          <div className="container-custom">
            {/* TITLE */}
            <div className="text-center mb-16">
              <div className="inline-flex items-center gap-3 bg-white shadow-md px-5 py-3 rounded-full mb-6">
                <div className="w-10 h-10 rounded-full bg-[#69bf74] flex items-center justify-center text-white">
                  <FaBullseye />
                </div>

                <span className="font-semibold text-[#0b1c39]">
                  Why Choose Us
                </span>
              </div>

              <h2 className="text-4xl md:text-5xl font-bold text-[#222] mb-5">
                Why Choose{' '}
                <span className="text-[#2e56b8]">
                  Wisdom Consultancy?
                </span>
              </h2>

              <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-8">
                We provide comprehensive financial solutions tailored to your
                goals and future financial security.
              </p>
            </div>

            {/* GRID */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                {
                  title: 'Expert Guidance',
                  desc: 'Professional investment and insurance solutions backed by 19+ years of industry experience.',
                  icon: '🎯',
                },
                {
                  title: 'Client-Centric',
                  desc: 'Every solution is customized according to your financial goals and future needs.',
                  icon: '🤝',
                },
                {
                  title: 'Goal-Based Wealth Planning',
                  desc: 'Strategic financial planning designed for education, retirement, wealth creation, and family security.',
                  icon: '📈',
                },
                {
                  title: 'Transparent & Ethical',
                  desc: 'We believe in honest guidance, complete transparency, and long-term client relationships.',
                  icon: '🛡️',
                },
              ].map((feature, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 25 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-white rounded-[30px] p-8 shadow-md hover:shadow-2xl transition-all duration-300 border border-transparent hover:border-[#dbe7ff] text-center group"
                >
                  <div className="w-20 h-20 rounded-3xl bg-[#edf3ff] flex items-center justify-center text-4xl text-[#2e56b8] mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                    {feature.icon}
                  </div>

                  <h3 className="text-2xl font-bold text-[#0b1c39] mb-4">
                    {feature.title}
                  </h3>

                  <p className="text-gray-600 leading-8">
                    {feature.desc}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* DIGITAL TOOLS */}
        <section className="py-20 relative z-10">
          <div className="container-custom">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-[#222] mb-5">
                Financial{' '}
                <span className="text-[#69bf74]">
                  Calculators
                </span>
              </h2>

              <p className="text-lg text-gray-600">
                Customized financial strategies focused on growth, protection,
                and future financial confidence.
              </p>
            </div>

            <div className="bg-white rounded-[35px] shadow-2xl p-6 md:p-10 border border-[#edf3ff]">
              <DigitalCalculator />
            </div>
          </div>
        </section>

        {/* SERVICES */}
        <section className="py-20 relative z-10">
          <div className="container-custom">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-[#222] mb-5">
                Empowering Your Financial Journey with{' '}
                <span className="text-[#2e56b8]">
                  Expert Solutions
                </span>
              </h2>

              <p className="text-lg text-gray-600">
                Comprehensive financial solutions tailored to your needs.
              </p>
            </div>

            {/* SERVICE GRID */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {expertServices.map((service, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 25 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="group bg-white rounded-[30px] p-8 shadow-md hover:shadow-2xl transition-all duration-300 border border-transparent hover:border-[#dbe7ff]"
                >
                  <div className="w-20 h-20 rounded-3xl bg-[#edf3ff] flex items-center justify-center text-4xl mb-6 group-hover:scale-110 transition-transform duration-300">
                    {service.icon}
                  </div>

                  <h3 className="text-2xl font-bold text-[#0b1c39] mb-4">
                    {service.name}
                  </h3>

                  <p className="text-gray-600 leading-8 mb-6">
                    {service.desc}
                  </p>

                  <Link
                    to="/services"
                    className="inline-flex items-center gap-3 text-[#2e56b8] font-semibold text-lg hover:gap-5 transition-all duration-300"
                  >
                    Learn More
                    <FaArrowRight />
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* TESTIMONIAL SECTION */}
        <section className="py-20 relative z-10">
          <div className="container-custom">
            <div className="text-center mb-16">
              <div className="inline-flex items-center gap-3 bg-white shadow-md px-5 py-3 rounded-full mb-6">
                <div className="w-10 h-10 rounded-full bg-[#69bf74] flex items-center justify-center text-white">
                  <FaStar />
                </div>

                <span className="font-semibold text-[#0b1c39]">
                  Client Testimonials
                </span>
              </div>

              <h2 className="text-4xl md:text-5xl font-bold text-[#222] mb-5">
                What Our{' '}
                <span className="text-[#69bf74]">
                  Clients Say
                </span>
              </h2>

              <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-8">
                Trusted by families and professionals for reliable financial
                planning and investment guidance.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {testimonials.map((testimonial, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-white rounded-[30px] p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-[#edf3ff] relative"
                >
                  <div className="absolute top-8 right-8 text-[#69bf74] text-3xl opacity-20">
                    <FaQuoteLeft />
                  </div>

                  <div className="flex gap-1 text-[#fbbf24] mb-6">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <FaStar key={star} />
                    ))}
                  </div>

                  <p className="text-gray-600 leading-8 mb-8">
                    "{testimonial.review}"
                  </p>

                  <div className="flex items-center gap-4">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#2e56b8] to-[#69bf74] flex items-center justify-center text-white text-2xl font-bold">
                      {testimonial.name.charAt(0)}
                    </div>

                    <div>
                      <h3 className="text-xl font-bold text-[#0b1c39]">
                        {testimonial.name}
                      </h3>

                      <p className="text-gray-500">
                        {testimonial.role}
                      </p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* STATS */}
        <section className="py-20 relative z-10">
          <div className="container-custom">
            <div className="bg-white rounded-[40px] shadow-2xl p-10 md:p-16 border border-[#e7f0eb]">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-10 text-center">
                {stats.map((stat, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, scale: 0.5 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ delay: index * 0.1 }}
                  >
                    <div className="text-4xl md:text-5xl font-bold text-[#2e56b8] mb-3">
                      {stat.value}
                    </div>

                    <div className="text-gray-600 text-lg">
                      {stat.label}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="pb-24 relative z-10">
          <div className="container-custom">
            <div className="bg-white rounded-[40px] shadow-2xl p-10 md:p-16 text-center border border-[#e7f0eb] relative overflow-hidden">
              {/* BG SHAPE */}
              <div className="absolute top-0 right-0 w-72 h-72 bg-[#edf3ff] rounded-full blur-3xl opacity-50" />

              <div className="relative z-10">
                <div className="inline-flex items-center gap-3 bg-[#edf3ff] px-5 py-3 rounded-full mb-8">
                  <div className="w-10 h-10 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
                    <FaChartLine />
                  </div>

                  <span className="font-semibold text-[#0b1c39]">
                    Free Financial Guidance
                  </span>
                </div>

                <h2 className="text-4xl md:text-5xl font-bold text-[#222] leading-tight mb-6">
                  Book a Free Consultation –{' '}
                  <span className="text-[#69bf74]">
                    with
                  </span>{' '}
                  Financial Experts
                </h2>

                <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-9 mb-10">
                  Strategic investment and insurance planning tailored to your
                  future needs.
                </p>

                <div className="flex flex-col sm:flex-row gap-5 justify-center">
                  <Link
                    to="/contact"
                    className="inline-flex items-center justify-center gap-3 bg-[#2e56b8] hover:bg-[#24479b] text-white px-8 py-5 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg"
                  >
                    Schedule Free Consultation
                    <FaArrowRight />
                  </Link>

                  <Link
                    to="/calculators"
                    className="inline-flex items-center justify-center gap-3 bg-[#69bf74] hover:bg-[#58ab63] text-white px-8 py-5 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg"
                  >
                    Try Our Calculators
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default Home;